import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';

Vue.component("publication-media", {
	props: ["appendixNumber", "partyId", "useTreeView","hasPartyFilter"],
	data() {
		return {
			loading: false,
			publicationMediaList: [],
			publicationMedias: [],
			data: new Tree([]),
			hasMediaFilter: false, 
			tableView: false,
			tableData: [],
			parties: [],
			party: null,
			media: null,
			resettable: false
		};
	},
	methods: {
		getByAppendixNumberPartyId: function () {
			this.loading = true;
			this.$services.publicationMediasService.getByAppendixNumberPartyId({
				appendixNumber: this.appendixNumber,
				partyId: this.partyId,
				language: window.currentLanguage,
				treeview: true,
				convertToHyperlink: true
			})
				.then((data) => {
					this.loading = false;
					this.publicationMedias = data;
					this.data = new Tree(data);
				});
		},
		checkExpandedNodes(nodes) {
			nodes.forEach((node, index) => {
				if(node.expanded) {
					let element = document.querySelectorAll('div.vtl div[id="' + node.id + '"] div.vtl-node-main span.vtl-caret i');
					if(element[0]) {
						element[0].click();
					}
				}
				if(node.children && node.children.length > 0) {
					this.checkExpandedNodes(node.children);
				}
			});
		},
		listByAppendixNumberPartyId: function () {
			const self = this;

			self.loading = true;

			self.$services.publicationMediasService.listByAppendixNumber({
				appendixNumber: self.appendixNumber,
				language: window.currentLanguage,
				partyId: self.partyId,
				media: self.media
			}).then((data) => {
				self.loading = false;
				self.tableData = data;
			});
		},
		loadByAppendixNumber: function () {
			const self = this;

			self.loading = true;
			self.tableData = [];

			self.$services.publicationMediasService.listByAppendixNumber({
				appendixNumber: self.appendixNumber,
				language: window.currentLanguage,
				partyId: self.party != null ? self.party.id : null,
				media: self.media
			}).then((data) => {
				self.loading = false;
				self.tableData = data;
			});
		},
		getPartiesForDropdown() {
			const self = this;
			self.$services.parties.getPartiesByAnnexNumber({
				annexNumber: 1,
				includeWTO: false,
				language: window.currentLanguage
			}).then((data) => {
				self.parties = data;
			});
		},
		search: function () {
			this.loadByAppendixNumber();
		},
		reset: function () {
			const self = this;

			self.resettable = false;
			self.party = null;
			self.media = null;
			self.loadByAppendixNumber();
		}
	},
	mounted() {
		const self = this;

		self.tableView = self.partyId == null || (self.partyId != null && self.partyId == '');

		if (self.partyId != null) {
			if (self.useTreeView) {
				self.getByAppendixNumberPartyId();
			}
			else {
				self.listByAppendixNumberPartyId();
			}
		}
		else {
			
			if (self.hasPartyFilter) {
				self.getPartiesForDropdown();
			}

			self.loadByAppendixNumber();
		}
	},
	watch: {
		party: function (value) {
			this.resettable = value != null;
		},
		media: function (value) {
			this.resettable = value != null;
		}
	},
	updated() {
		const self = this;

		if (self.useTreeView) {
			self.$nextTick(() => {
				if (self.$refs.treeview) {
					if (self.$refs.treeview.model.children) {
						self.checkExpandedNodes(self.$refs.treeview.model.children);
					}
				}
			});
		}
	},
	computed: {
		searchLabel: function () {
			return window.labels.search;
		},
		resetLabel: function () {
			return window.labels.reset;
		},
		searchPublicationMediaLabel: function () {
			return window.labels.searchPublicationMedia;
		},
		selectAPartyLabel: function () {
			return window.labels.selectAParty;
		},
		partyLabel: function () {
			return window.labels.party;
		},
		publicationMediaLabel: function () {
			return window.labels.publicationMedia;
		},
		noPublicationMediaFoundLabel: function () {
			return window.labels.noPublicationMediaFound;
		}
	},
	template: `
		<div>
			<div class="columns">
				<div class="column is-12 p-1">
					<b-field grouped>
						<b-field expanded>
							<b-select v-if="hasPartyFilter" v-model="party" :placeholder="selectAPartyLabel" icon="earth">
								<option v-for="party in parties"
										:value="party"
										:key="party.id"> {{ party.name }}</option>
							</b-select>
							<b-input :placeholder="searchPublicationMediaLabel" v-model="media" expanded></b-input>
							<p class="control">
								<b-button :label="searchLabel" type="is-primary" @click="search" />
							</p>
							<p class="control" v-if="resettable">
								<b-button :label="resetLabel" type="is-danger" @click="reset" />
							</p>
						</b-field>
					</b-field>
				</div>
			</div>
			<div v-if="tableView">
				<template v-if="loading"><loading></loading></template>
				<template v-else>
					<div class="columns">
						<div class="column" v-if="tableData != null && tableData.length > 0">
							<b-table :data="tableData">
								<b-table-column :label="partyLabel" width="200">
									<template v-slot="props">
										<span style="text-transform: uppercase; font-weight: bold; color: #006283">{{ props.row.partyName }}</span>
									</template>
								</b-table-column>
								<b-table-column :label="publicationMediaLabel">
									<template v-slot="props">
										<div v-for="column in props.row.columns" :key="column.id" :id="column.id">
											<div :style="{'margin-left': column.indentation}" v-if="column.visible" v-html="column.text"></div>
										</div>
									</template>
								</b-table-column>
							</b-table>
						</div>
						<div class="column" v-else>
							<b-message type="is-info">{{noPublicationMediaFoundLabel}}</b-message>
						</div>
					</div>
				</template>
			</div>
			<div v-else>
				<div class="annex-entities" v-if="useTreeView">
					<template v-if="loading"><loading></loading></template>
					<template v-else>
						<vue-tree-list
							ref="treeview"
							:model="data"
							v-bind:default-expanded="false">
							<template v-slot:leafNameDisplay="props">
								<div class="entity-row">
						  			<div class="entity-row-reference-number pr-2">{{ props.model.referenceNumber }}</div>
									<div class="entity-row-display-name">
										<span v-html="props.model.name" :class="{'has-text-weight-bold': props.model.highlightTitle}"></span>
									</div>
								</div>
							</template>
							<template v-slot:treeNodeIcon="props">
  								<span class="icon">
									<i v-if="props.model.children && props.model.children.length > 0" class="fa fa-sitemap"></i>
									<i v-else class="fa fa-fw"></i>
								</span>
							</template>
						</vue-tree-list>
					</template>
				</div>
				<div v-else>
					<template v-if="loading"><loading></loading></template>
					<template v-else>
						<div v-if="tableData != null && tableData.length > 0 && tableData[0] != null && tableData[0].columns != null && tableData[0].columns.length > 0">
							<div v-for="column in tableData[0].columns" :key="column.id" :id="column.id">
								<div :style="{'margin-left': column.indentation}" v-if="column.visible" v-html="column.text"></div>
							</div>							
						</div>
					</template>
				</div>
			</div>
		</div>
	`
});